import { render } from "./TermView.vue?vue&type=template&id=93c40c1e&scoped=true"
import script from "./TermView.vue?vue&type=script&lang=js"
export * from "./TermView.vue?vue&type=script&lang=js"

import "./TermView.vue?vue&type=style&index=0&id=93c40c1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93c40c1e"]])

export default __exports__